/** @format */
import { colors } from '@mui/material';

const white = '#FFFFFF';
const black = '#000000';
// const red = colors.red[500];
// const green = colors.green[500];

export default {
  black,
  // white,
  primary: {
    contrastText: white,
    darker: '#091757',
    dark: '#0D1C6A',
    main: '#2B3990',
    light: '#D9E8FF',
    lighter: '#e5efff',
  },
  secondary: {
    contrastText: '#ffeacb',
    dark: '#513102',
    main: '#fbaa33',
    light: '#ffeacb',
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: '#006cfc',
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: '#2B3990',
  },
  background: {
    default: '#f8f9fa',
    paper: white,
  },
  gray: {
    0: '#f8fafb',
    1: '#eceff1',
    2: '#cfd8dc',
    3: '#b0bec5',
    6: '#546e7a',
    7: '#30414a',
  },
  icon: colors.blueGrey[100],
  divider: colors.grey[200],
  sideBar: '#2B3990',
  title: '#1d4065',
};
